// useIframeAutoHeight.js
import { useEffect, useRef } from 'react';

export function useIframeAutoHeight() {
  const rafId = useRef(null);

  useEffect(() => {
    const postHeight = () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
      rafId.current = requestAnimationFrame(() => {
        const { body, documentElement } = document;
        const height = Math.max(
          body?.scrollHeight || 0,
          documentElement?.scrollHeight || 0,
          body?.offsetHeight || 0,
          documentElement?.offsetHeight || 0,
          body?.clientHeight || 0,
          documentElement?.clientHeight || 0
        );

        // 👉 an *alle* Parent-Domains senden
        window.parent.postMessage({ type: 'IFRAME_HEIGHT', height }, '*');
      });
    };

    // 1) Initial und nach Fonts/Bildern
    window.addEventListener('load', postHeight);

    // 2) Auf Layout-Änderungen reagieren
    const ro = new ResizeObserver(() => postHeight());
    ro.observe(document.documentElement);

    // 3) Auf Anfrage vom Parent reagieren
    const onMessage = (e) => {
      if (e.data && e.data.type === 'REQUEST_IFRAME_HEIGHT') {
        postHeight();
      }
    };
    window.addEventListener('message', onMessage);

    // 5) Direkt initial posten
    postHeight();

    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
      window.removeEventListener('load', postHeight);
      window.removeEventListener('message', onMessage);
      ro.disconnect();
    };
  }, []);
}
